@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.ChartEmptyState {
  @extend %font-family-primary;

  display: flex;
  flex-direction: column;
  row-gap: 8px;
  text-align: center;
  align-items: center;
  justify-content: center;
  height: 100%;

  .Icon {
    color: $color-primary-purple;
    opacity: 0.4;

    svg {
      height: 24px;
      width: 24px;
    }
  }

  .Link {
    margin-top: 8px;
  }
}
